import { translatePhysicalProductType } from '@/helpers/translateProductType';

const FormatTypeRenderer = (props: any) => {
  return (
    <div className="badge format-badge badge-default">
      {translatePhysicalProductType(props.data.format?.name)}
    </div>
  );
};

export default FormatTypeRenderer;
